<template>
  <div class="form" v-if="isPromptActiveLocal ? true : false">
    <p class="form_title">Connexion</p>
    <p class="form_subtitle">
      <span class="yello_word">Y’ello</span>, veuillez vous connecter
    </p>
    <div class="form_field">
      <vs-input @keypress.enter="loginAgentAcademy()"
        autocomplete="off"
        v-model="email"
        :danger="!!formErrors.email"
        :danger-text="formErrors.email ? formErrors.email[0] : ''"
        name="email"
        class="w-full"
        label="E-mail / Numéro de téléphone"
      />
    </div>

    <vs-button color="#ffcc00" class="action_button text-dark" @click="loginAgentAcademy()"
      >Se connecter</vs-button
    >

    <p class="link_auth mt-10 ml-2" @click="toggleRegisterPrompt()">S'inscrire</p>
  </div>
</template>

<script>
export default {
  name: "LoginEntryAgentAcademy",
  data: () => ({
    email: "",
    formErrors: {},
  }),
  props: {
    isPromptActive: {
      type: Boolean,
      required: true,
    },
    callBackLogin: {
      type: Function,
    },
  },
  watch: {
    isPromptActive(val) {
      if (!val) return;
    },
  },
  computed: {
    isPromptActiveLocal: {
      get() {
        if (this.isPromptActive) {
          //   this.resetErrors();
          this.formErrors = {}
        }
        return this.isPromptActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closePrompt");
        }
      },
    },
  },
  methods: {
    toggleRegisterPrompt(){
      this.$emit("toggleRegisterFormPrompt");
    },
    async loginAgentAcademy() {
      this.$vs.loading();
      let payload = {
        email: this.email,
        origin: 'web'
      };

      try {
        let response = await this.$http.post("auth/aa/login", payload);
        this.$vs.loading.close();
        if (response.data) {
          this.$vs.notify({
            title: "Succès",
            text: "Opération effectuée avec succès",
            iconPack: "feather",
            icon: "icon-check",
            color: "success",
            position: "top-right",
          });
          this.email = "";
          this.formErrors = {};
          this.callBackLogin({
            status: true,
            email: payload.email,
            phone: response.data.user.phone
          });
        }
      } catch (error) {
        this.$vs.loading.close();
        if (error.response.status == 422) {
          this.formErrors = error.response.data.errors;
        } else {
          this.formErrors = {};
          this.$vs.notify({
            title: "Erreur",
            text: error.response.data.message
              ? error.response.data.message
              : "Veuillez contacter l'administrateur",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
        }
      }
    },
  },
};
</script>

<style>
</style>